import { FlexClasses_FlexShrinkGrow_$ctor_Z207A3CFB, FlexClasses_Order_$ctor_Z207A3CFB, FlexClasses_AlignContent_$ctor_Z207A3CFB, FlexClasses_AlignItems_$ctor_Z207A3CFB, FlexClasses_AlignSelf_$ctor_Z207A3CFB, FlexClasses_JustifyItems_$ctor_Z207A3CFB, FlexClasses_JustifySelf_$ctor_Z207A3CFB, FlexClasses_JustifyContent_$ctor_Z207A3CFB, FlexClasses_FlexBasis_$ctor_Z207A3CFB, FlexClasses_FlexWrap_$ctor_Z207A3CFB, FlexClasses_FlexDirection_$ctor_Z207A3CFB } from "../Types/Flex.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const FlexDirection = FlexClasses_FlexDirection_$ctor_Z207A3CFB(new Property_CssProperty(99));

export const FlexWrap = FlexClasses_FlexWrap_$ctor_Z207A3CFB(new Property_CssProperty(105));

export const FlexBasis = FlexClasses_FlexBasis_$ctor_Z207A3CFB(new Property_CssProperty(98));

export const JustifyContent = FlexClasses_JustifyContent_$ctor_Z207A3CFB(new Property_CssProperty(148));

export const JustifySelf = FlexClasses_JustifySelf_$ctor_Z207A3CFB(new Property_CssProperty(150));

export const JustifyItems = FlexClasses_JustifyItems_$ctor_Z207A3CFB(new Property_CssProperty(149));

export const AlignSelf = FlexClasses_AlignSelf_$ctor_Z207A3CFB(new Property_CssProperty(3));

export const AlignItems = FlexClasses_AlignItems_$ctor_Z207A3CFB(new Property_CssProperty(2));

export const AlignContent = FlexClasses_AlignContent_$ctor_Z207A3CFB(new Property_CssProperty(1));

export const Order = FlexClasses_Order_$ctor_Z207A3CFB(new Property_CssProperty(189));

export const FlexShrink = FlexClasses_FlexShrinkGrow_$ctor_Z207A3CFB(new Property_CssProperty(104));

export const FlexGrow = FlexClasses_FlexShrinkGrow_$ctor_Z207A3CFB(new Property_CssProperty(103));

